import styled from '@emotion/styled';
import { Body } from '@components/templates/PageBody';

export const MailSettingsBody = styled(Body)`
  box-sizing: border-box;
  min-width: 505px;
  width: 100%;
  height: 530px;
  display: flex;
  align-items: center;
  padding: 30px;
  margin: 18px auto 0;
`;
export const MailIcon = styled.div`
  margin: 0 60px;
  min-width: 240px;
  min-height: 240px;
  border-radius: 100%;
  background: #effdda;
  display: flex;
  align-items: center;
  justify-content: center;
  & > img {
    width: 111px;
    height: 100px;
  }
`;
